import { render, staticRenderFns } from "./SectionsCli.vue?vue&type=template&id=36efd0c8&scoped=true&"
import script from "./SectionsCli.vue?vue&type=script&lang=js&"
export * from "./SectionsCli.vue?vue&type=script&lang=js&"
import style0 from "./SectionsCli.vue?vue&type=style&index=0&id=36efd0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efd0c8",
  null
  
)

export default component.exports